module.exports = __webpack_public_path__ + "static/media/A1-34-Retaliação-Feroz-cod142.a380fc1c.png";